import { Meta } from '../../Meta';
import { PostSummary } from '../utils';
import { BlogHomeHeroSection } from './HeroSection';
import { BlogHomePostsSection } from './PostsSection';
import { MarketingPage } from '../../marketing/MarketingPage';

interface Props {
  posts: PostSummary[];
}

export const BlogHome = ({ posts }: Props) => {
  return (
    <MarketingPage>
      <Meta title="Blog">
        <meta property="og:title" content="Wolfia Blog" />
        <meta property="og:image" content="/images/meta/og-image.png" />
        <meta
          property="og:description"
          content="The latest news about Wolfia and AI compliance."
        />
      </Meta>
      <BlogHomeHeroSection />
      <BlogHomePostsSection posts={posts} />
    </MarketingPage>
  );
};
